module.exports = __webpack_public_path__ + "static/img/bg.514a66a1.png";